import dayjs, { Dayjs } from 'dayjs';

import {
  IReportDetail,
  IReportPageData,
  IAIInclination,
  IChartStackedBarValue,
  INCLINATION_KEYS,
  INCLINATION_LABELS,
  IChartVisibilityValue,
} from '@/constants/geo';
import { ReportWebTemplateRes } from '@/axios/geo';

/** 输入小数返回百分比数并保留一位小数并返回 number 类型 */
export const toPercentageNumber = (num: number) => {
  return Number((num * 100).toFixed(1));
};

/** 将 IReportDetail 转换成 IReportPageData */
export const convertReportDetailToPageData = (config: {
  reportDetail: IReportDetail;
  oemConfig: ReportWebTemplateRes;
}): IReportPageData => {
  const { reportDetail, oemConfig } = config;
  console.log('==>detail', reportDetail);

  const {
    aiVisibility = { visiblePercent: 0 },
    aiVisibilityPlatformData = {},
    aiInclination = { positiveTotal: 0, positivePercent: 0, neutralTotal: 0, neutralPercent: 0, negativeTotal: 0, negativePercent: 0 },
    aiInclinationPlatformData = {},
    competitor = { items: [], total: 0 },
    competitorPlatformData = {},
    platformMappings = [],
    updateTime,
    aiVisibilityPlatformPercentData,
  } = reportDetail || {};
  const { keywordsConfig } = reportDetail || {};
  const { coreKeywords } = keywordsConfig;
  const updateTimeDate = dayjs(updateTime);
  /** 获取星期几的英文缩写, 如  FRI */
  const dayOfWeek = updateTimeDate.locale('en').format('ddd').toUpperCase();
  /** AI 可见性平台列表 */
  const aiPlatformList = Object.keys(aiVisibilityPlatformData);
  aiPlatformList.sort((a, b) => {
    const aIndex = platformMappings.findIndex((row) => row.platform === a);
    const bIndex = platformMappings.findIndex((row) => row.platform === b);
    if (aIndex === -1) {
      return 1;
    }
    if (bIndex === -1) {
      return -1;
    }
    return aIndex - bIndex;
  });

  /** 品牌舆情度 */
  const aiInclinationNumber = aiInclination
  /** 品牌竞争度 */
  const brandCompetitivenessData =
    competitor.items?.map((item) => {
      return {
        name: item.name,
        value: item.count,
        percentage: competitor.total ? toPercentageNumber(item.count / competitor.total) : 0,
      };
    }) || [];
  const platforms = Object.keys(competitorPlatformData).sort((a, b) => {
    const aIndex = platformMappings.findIndex((row) => row.platform === a);
    const bIndex = platformMappings.findIndex((row) => row.platform === b);
    if (aIndex === -1) {
      return 1;
    }
    if (bIndex === -1) {
      return -1;
    }
    return aIndex - bIndex;
  });
  // 组装成不同竞品不同平台的二维数组数据结构
  const brands = competitorPlatformData[platforms[0]]?.items?.map((item) => item.name) || [];
  const brandCompetitivenessPlatformChartData = new Array(brands.length).fill(0).map((_, i) => {
    return aiPlatformList.map((platform) => {
      const platformData = competitorPlatformData[platform];
      const item = platformData?.items?.[i];
      const value = item?.count || 0;
      const rate = platformData?.total ? value / platformData.total : 0;
      return {
        value,
        realValue: toPercentageNumber(rate),
        label: item?.name || '',
      };
    });
  });
  /** AI 可见性平台数字数据 */
  const aiVisibilityPlatformNumberData: IChartVisibilityValue[] = aiPlatformList.map((platform) => {
    const platformData = aiVisibilityPlatformData[platform] || {};
    return {
      value: platformData.totalVisible,
      realValue: platformData.visiblePercent,
    };
  });
  /** 各平台曝光度占比表格数据 */
  const platformVisibleTableData = aiPlatformList.map((platform) => {
    const platformData = aiVisibilityPlatformPercentData[platform] || { visible: 0, percent: 0 };
    return {
      searchWords: platformData.visible || 0,
      platform,
      percentage: platformData.percent,
    };
  });

  /** 各平台推荐情况 */
  const aiInclinationPlatformChartData: IChartStackedBarValue[][] = INCLINATION_KEYS.map((el, index) => {
    return aiPlatformList.map((platform) => {
      const platformData = aiInclinationPlatformData[platform] || {};
      return {
        value: (platformData as any)?.[el + 'Total'],
        realValue: (platformData as any)?.[el + 'Percent'],
        label: INCLINATION_LABELS[index],
      };
    });
  });

  return {
    name: 'GEO搜索推广数据看板',
    dateInfo: {
      year: updateTimeDate.year(),
      dayOfWeek,
      date: updateTimeDate.format('MM.DD'),
    },
    aiPlatformList,
    aiPlatformNameList: aiPlatformList.map((platform) => platformMappings.find((row) => row.platform === platform)?.name || platform),
    isFewPlatforms: aiPlatformList.length <= 3,
    coreKeywords: coreKeywords || [],
    // 品牌搜索指数
    aiVisibilityNumber: aiVisibility?.visiblePercent || 0,
    // 品牌舆情度
    aiInclinationNumber,
    // 各平台曝光情况数据
    aiVisibilityPlatformNumberData,
    // 各平台推荐情况数据
    aiInclinationPlatformChartData,
    oemConfig,
    // 品牌竞争度数据
    brandCompetitivenessData,
    // 品牌竞争度平台数据
    brandCompetitivenessPlatformChartData,
    platformMappings,
    // 各平台已覆盖词量占比数据
    platformVisibleTableData,
    reportDetail,
  };
};
